export function random (min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min)
};

/**
 * Randomize array element order in-place.
 * Using Durstenfeld shuffle algorithm.
 */
export const shuffleArray = (array) => {
  for (let i = array.length - 1; i > 0; i--) {
    let j = Math.floor(Math.random() * (i + 1))
    let temp = array[i]
    array[i] = array[j]
    array[j] = temp
  }
  return array
};

export const debug = false;
export const test = true;

export const URL_AUFTRAGSBUCH = debug ? 'https://auftragsbuch.bis.com:9090/#/' : (test ? 'https://auftragsbuch.test-bisoffice.de' : 'https://auftragsbuch.bisoffice.app/#/');


export const Server_URL = debug ? 'https://bis.com:7777' : (test ? 'https://baumkontrolle.test-bisoffice.de' : 'https://baumkontrolle.bisoffice.app');

export const Server_URL_BASE = debug ? 'https://bis.com:1331' : (test ? 'https://test-bisoffice.de' : 'https://bisoffice.app');



export const Redirect_Login = debug ? 'https://bis.com:8080/#/pages/login' : (test ? 'https://test-bisoffice.de/#/pages/login' : 'https://bisoffice.app/#/pages/login');


export const Redirect_500 = debug ? 'https://bis.com:8080/#/pages/page500' : (test ? 'https://test-bisoffice.de/#/pages/page500' : 'https://bisoffice.app/#/pages/page500');


export const Redirect_Admin = debug ? 'https://bis.com:8080/#/administration' : (test ? 'https://test-bisoffice.de/#/administration' : 'https://bisoffice.app/#/administration');
export const HUB_SERVER = debug ? 'https://bis.com:8888' : (test ? 'https://test-bisoffice.de/hub/hub.html' : 'https://bisoffice.app/hub/hub.html');
export const URL_NUTZERVERWALTUNG = debug ? 'https://bis.com:8080/#/user_management' : (test ? 'https://test-bisoffice.de/#/user_management' : 'https://bisoffice.app/#/user_management');
export const URL_MOBILE_SETTINGS = debug ? 'https://bis.com:8080/#/mobile_settings' : (test ? 'https://test-bisoffice.de/#/mobile_settings' : 'https://bisoffice.app/#/mobile_settings');
export const URL_ZEITKONTROLLE = debug ? 'https://zeitkontrolle.bis.com:9070/#/' : (test ? 'https://zeitkontrolle.test-bisoffice.de/#/' : 'https://zeitkontrolle.bisoffice.app/#/');

export const URL_BAUMKONTROLLE = debug ? 'https://baumkontrolle.bis.com:9091/#/' : (test ? 'https://baumkontrolle.test-bisoffice.de/#/' : 'https://baumkontrolle.bisoffice.app/#/');


export const Cookie_Path = test ? '.test-bisoffice.de' : '.bisoffice.app';
